/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type UserUpdateInput = {
  givenName?: string | null;
  familyName?: string | null;
  email?: string | null;
  organizationId?: string | null;
  username?: string | null;
  role?: RoleType | null;
  accountStatus?: OrganizationUserStatus | null;
  groupsCanRead?: Array<string> | null;
};

export enum RoleType {
  ADMIN = 'ADMIN',
  HOST = 'HOST'
}

export enum OrganizationUserStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED'
}

export type UserUpdateHostDataInput = {
  hostTipsEnabled?: boolean | null;
  hasHostedGame?: boolean | null;
};

export type User = {
  __typename: 'User';
  id: string;
  givenName: string;
  familyName: string;
  email: string;
  emailVerified: boolean;
  roles: Array<string | null>;
  hostTipsEnabled: boolean;
  hasHostedGame: boolean;
  organizationId?: string | null;
  username?: string | null;
  role?: RoleType | null;
  accountStatus?: OrganizationUserStatus | null;
  groupsCanRead?: Array<string> | null;
  createdAt: string;
  updatedAt: string;
};

export type UserCreateInput = {
  sub: string;
  email: string;
  organizationId?: string | null;
  username: string;
  role?: RoleType | null;
  accountStatus?: OrganizationUserStatus | null;
  groupsCanRead?: Array<string> | null;
};

export type SessionCreateInput = {
  promptIds: Array<string>;
  questionType: QuestionType;
  organizationId?: string | null;
};

export enum QuestionType {
  CREATIVITY = 'CREATIVITY',
  PARTICIPATION = 'PARTICIPATION',
  CONNECTED = 'CONNECTED'
}

export type Session = {
  __typename: 'Session';
  id: string;
  hostId?: string | null;
  data: SessionData;
  organizationId?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export type SessionData = {
  __typename: 'SessionData';
  status: SessionStatus;
  players: Array<Player>;
  rounds: Array<Round>;
  questionType: QuestionType;
};

export enum SessionStatus {
  created = 'created',
  drawing = 'drawing',
  ending = 'ending',
  ended = 'ended',
  sharing = 'sharing'
}

export type Player = {
  __typename: 'Player';
  id: string;
  name: string;
  gameStatus: PlayerGameStatus;
  connectionStatus: PlayerConnectionStatus;
  feelingBefore?: number | null;
  feelingAfter?: number | null;
  question?: string | null;
  questionAnswer?: boolean | null;
  sessionId: string;
  session?: Session | null;
  organizationId?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export enum PlayerGameStatus {
  SETUP = 'SETUP',
  DRAWING = 'DRAWING',
  SUBMITTED = 'SUBMITTED',
  SHARING = 'SHARING',
  SHARED = 'SHARED',
  READY = 'READY'
}

export enum PlayerConnectionStatus {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED'
}

export type Round = {
  __typename: 'Round';
  id: string;
  index: number;
  isCurrent: boolean;
  isLast: boolean;
  promptId: string;
  artwork: Array<Artwork>;
};

export type Artwork = {
  __typename: 'Artwork';
  id: string;
  drawing: string;
  playerId: string;
};

export type NewRoundUpdate = {
  __typename: 'NewRoundUpdate';
  round: number;
  sessionStatus: SessionStatus;
  playerStatus: PlayerGameStatus;
};

export type SharingPlayer = {
  __typename: 'SharingPlayer';
  playerId: string;
};

export type NewPlayer = {
  __typename: 'NewPlayer';
  session: Session;
  newPlayer: Player;
};

export enum GamePackIcon {
  ICE = 'ICE',
  LIGHT_BULB = 'LIGHT_BULB',
  PUMPKIN = 'PUMPKIN',
  SUN = 'SUN',
  ORANGE_STAR = 'ORANGE_STAR',
  ROCKET = 'ROCKET',
  HEART = 'HEART',
  COFFEE = 'COFFEE',
  PENCIL = 'PENCIL',
  GREEN_LEAF = 'GREEN_LEAF',
  GREEN_STAR = 'GREEN_STAR',
  BLOCKS = 'BLOCKS',
  EAR = 'EAR',
  LEAVES = 'LEAVES',
  SHOOTING_STAR = 'SHOOTING_STAR'
}

export enum GamePackPalette {
  BLUE = 'BLUE',
  ORANGE = 'ORANGE',
  ROSE_RED = 'ROSE_RED',
  RED = 'RED',
  LIGHT_GREEN = 'LIGHT_GREEN',
  GREEN = 'GREEN',
  DARK_GREEN = 'DARK_GREEN',
  NAVY_BLUE = 'NAVY_BLUE'
}

export enum GamePackStatus {
  ACTIVE = 'ACTIVE',
  DISABLED = 'DISABLED'
}

export type GamePack = {
  __typename: 'GamePack';
  id: string;
  name: string;
  description: string;
  category1?: string | null;
  category2?: string | null;
  category3?: string | null;
  icon: GamePackIcon;
  palette: GamePackPalette;
  isFeatured: boolean;
  showInDiscover: boolean;
  isNew: boolean;
  order: number;
  groups?: Array<string> | null;
  status: GamePackStatus;
  prompts?: Array<Prompt> | null;
  organizations?: Array<Organization> | null;
  gamePackPrompts?: Array<GamePackPrompts> | null;
  gamePackOrganizations?: Array<GamePackOrganizations> | null;
  createdAt: string;
  updatedAt: string;
};

export type Prompt = {
  __typename: 'Prompt';
  id: string;
  text: string;
  subdomain?: string | null;
  deletedAt?: string | null;
  gamePacks?: Array<GamePack> | null;
  gamePackPrompts?: Array<GamePackPrompts> | null;
  createdAt: string;
  updatedAt: string;
};

export type GamePackPrompts = {
  __typename: 'GamePackPrompts';
  id: string;
  promptId: string;
  gamePackId: string;
  prompt: Prompt;
  gamePack: GamePack;
  createdAt: string;
  updatedAt: string;
};

export type Organization = {
  __typename: 'Organization';
  id: string;
  name: string;
  tenant: string;
  subdomain: string;
  emailDomains: Array<string>;
  groupsCanRead?: Array<string> | null;
  organizationActive?: boolean | null;
  hostLicenses: number;
  adminLicenses: number;
  gamePacks?: Array<GamePack> | null;
  gamePackOrganizations?: Array<GamePackOrganizations> | null;
  activeUsers?: number | null;
  activeHosts?: number | null;
  activeAdmins?: number | null;
  onFreeTrial: boolean;
  freeTrialExpiration?: string | null;
  createdAt: string;
  updatedAt: string;
};

export type GamePackOrganizations = {
  __typename: 'GamePackOrganizations';
  id: string;
  gamePackId: string;
  organizationId: string;
  gamePack: GamePack;
  organization: Organization;
  createdAt: string;
  updatedAt: string;
};

export type GamePackOrderInput = {
  id: string;
  order: number;
};

export type OrganizationCreateInput = {
  name: string;
  subdomain: string;
  emailDomains: Array<string>;
  groupsCanRead?: Array<string> | null;
  organizationActive?: boolean | null;
  hostLicenses: number;
  adminLicenses: number;
  onFreeTrial: boolean;
  freeTrialExpiration?: string | null;
};

export type OrganizationUpdateInput = {
  id: string;
  name?: string | null;
  subdomain?: string | null;
  emailDomains?: Array<string> | null;
  groupsCanRead?: Array<string> | null;
  organizationActive?: boolean | null;
  hostLicenses?: number | null;
  adminLicenses?: number | null;
  onFreeTrial: boolean;
  freeTrialExpiration?: string | null;
};

export type UserInviteInput = {
  email: string;
  firstName: string;
  lastName: string;
  organizationId: string;
  isAdmin: boolean;
};

export type PlayerCreateInput = {
  name: string;
  sessionId: string;
  connectionStatus?: PlayerConnectionStatus | null;
  gameStatus?: PlayerGameStatus | null;
  organizationId?: string | null;
};

export type PlayerUpdateInput = {
  name?: string | null;
  connectionStatus?: PlayerConnectionStatus | null;
  gameStatus?: PlayerGameStatus | null;
  feelingBefore?: number | null;
  feelingAfter?: number | null;
  question?: string | null;
  questionAnswer?: boolean | null;
  organizationId?: string | null;
};

export type GameCreateInput = {
  promptText: string;
  sessionId: string;
  gameIndex: number;
  promptGamePackId?: string | null;
  status?: GameStatus | null;
  isCurrent?: boolean | null;
  isLast?: boolean | null;
};

export enum GameStatus {
  CREATED = 'CREATED',
  DRAWING = 'DRAWING',
  SHARING = 'SHARING',
  ENDED = 'ENDED'
}

export type Game = {
  __typename: 'Game';
  id: string;
  promptText: string;
  promptGamePackId?: string | null;
  status: GameStatus;
  gameIndex: number;
  isCurrent: boolean;
  isLast: boolean;
  sessionId: string;
  session?: Session | null;
  createdAt: string;
  updatedAt: string;
};

export type GameUpdateInput = {
  promptText?: string | null;
  promptGamePackId?: string | null;
  status?: GameStatus | null;
  isCurrent?: boolean | null;
  isLast?: boolean | null;
};

export type PlayerCardCreateInput = {
  gameId: string;
  playerId: string;
  sessionId: string;
  drawing?: string | null;
  drawingLines?: string | null;
  timesStoryMadeFeelGood?: number | null;
  timesStoryWasRelated?: number | null;
  timesStoryWasShared?: number | null;
};

export type PlayerCard = {
  __typename: 'PlayerCard';
  id: string;
  drawing?: string | null;
  drawingLines?: string | null;
  timesStoryMadeFeelGood: number;
  timesStoryWasRelated: number;
  timesStoryWasShared: number;
  gameId: string;
  playerId: string;
  sessionId: string;
  game?: Game | null;
  player?: Player | null;
  session?: Session | null;
  artworkReactions: Array<ArtworkReaction>;
  createdAt: string;
  updatedAt: string;
};

export type ArtworkReaction = {
  __typename: 'ArtworkReaction';
  id: string;
  reaction: number;
  playerCardId: string;
  playerId: string;
  sessionId: string;
  playerCard?: PlayerCard | null;
  player?: Player | null;
  session?: Session | null;
};

export type PlayerCardUpdateInput = {
  drawing?: string | null;
  drawingLines?: string | null;
  timesStoryMadeFeelGood?: number | null;
  timesStoryWasRelated?: number | null;
  timesStoryWasShared?: number | null;
};

export enum ReactionType {
  FEEL_GOOD = 'FEEL_GOOD',
  RELATED = 'RELATED',
  SHARED = 'SHARED'
}

export type GamePackPromptsCreateInput = {
  promptId: string;
  gamePackId: string;
};

export type GamePackPromptsUpdateInput = {
  promptId?: string | null;
  gamePackId?: string | null;
};

export type GamePackOrganizationsCreateInput = {
  gamePackId: string;
  organizationId: string;
};

export type GamePackOrganizationsUpdateInput = {
  gamePackId?: string | null;
  organizationId?: string | null;
};

export type ArtworkReactionCreateInput = {
  reaction: number;
  playerCardId: string;
  playerId: string;
  sessionId: string;
};

export type RedisArtworkReaction = {
  __typename: 'RedisArtworkReaction';
  reaction: number;
  playerCardId: string;
  playerId: string;
  sessionId: string;
};

export type AsyncTaskInput = {
  type: string;
  payload?: string | null;
};

export type AsyncTask = {
  __typename: 'AsyncTask';
  id: string;
  type: string;
  status: AsyncTaskStatus;
  payload?: string | null;
  result?: string | null;
  error?: string | null;
  createdBy?: string | null;
  tenant?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export enum AsyncTaskStatus {
  pending = 'pending',
  running = 'running',
  succeeded = 'succeeded',
  failed = 'failed'
}

export type OrganizationUserFilter = {
  organizationId?: OrganizationIDFilter | null;
  accountStatus?: AccountStatusFilter | null;
};

export type OrganizationIDFilter = {
  eq?: string | null;
};

export type AccountStatusFilter = {
  ne?: string | null;
};

export type UserConnection = {
  __typename: 'UserConnection';
  items: Array<User>;
  nextToken?: string | null;
};

export type OrganizationUserRoleCounts = {
  __typename: 'OrganizationUserRoleCounts';
  adminCount: number;
  hostCount: number;
};

export type OrganizationUserCount = {
  __typename: 'OrganizationUserCount';
  organizationId: string;
  count: number;
};

export type OrganizationPublic = {
  __typename: 'OrganizationPublic';
  id: string;
  name: string;
  subdomain: string;
  tenant: string;
};

export type PlayerCardDrawings = {
  __typename: 'PlayerCardDrawings';
  id: string;
  drawing?: string | null;
  drawingLines?: string | null;
  gameId: string;
  player?: PlayerName | null;
};

export type PlayerName = {
  __typename: 'PlayerName';
  name: string;
};

export type PlayerCardReactionCounts = {
  __typename: 'PlayerCardReactionCounts';
  feelGood: number;
  related: number;
  shared: number;
};

export type ArtworkReactionFilterInput = {
  reaction?: number | null;
  playerCardId?: string | null;
  playerId?: string | null;
  sessionId: string;
  and?: Array<ArtworkReactionFilterInput | null> | null;
  or?: Array<ArtworkReactionFilterInput | null> | null;
  not?: ArtworkReactionFilterInput | null;
};

export type ReactionCount = {
  __typename: 'ReactionCount';
  reactionType: number;
  count: number;
};

export type Metrics = {
  __typename: 'Metrics';
  updatedAt?: string | null;
  sentimentIncrease: number;
  totalPlayers: number;
  sentimentCount: number;
  gamesHosted: number;
  questionScore: Array<MetricEntry>;
  reactionScore: Array<MetricEntry>;
  totalHosts?: number | null;
  storiesShared?: number | null;
  medianRoundTime?: number | null;
  popularPrompt?: string | null;
  popularGamePack?: string | null;
  avgPlayersPerGame?: number | null;
  avgRoundsPerGame?: number | null;
  avgGameLengthMin?: number | null;
  activityTimeline: Array<MetricEntry>;
  customPromptsCount?: number | null;
};

export type MetricEntry = {
  __typename: 'MetricEntry';
  label: string;
  value: number;
};

export type HostUpdate =
  | NewPlayerUpdate
  | NewDrawingUpdate
  | NewReactionUpdate
  | SessionStatusUpdate;

export type NewPlayerUpdate = {
  __typename: 'NewPlayerUpdate';
  player: Player;
};

export type NewDrawingUpdate = {
  __typename: 'NewDrawingUpdate';
  artwork?: Artwork | null;
};

export type NewReactionUpdate = {
  __typename: 'NewReactionUpdate';
  reaction?: RedisArtworkReaction | null;
};

export type SessionStatusUpdate = {
  __typename: 'SessionStatusUpdate';
  status: SessionStatus;
};

export type PlayerUpdate =
  | NewRoundUpdate
  | SharingPlayer
  | NewDrawingUpdate
  | NewPlayerUpdate
  | SessionStatusUpdate;

export type UserUpdateMeMutationVariables = {
  input: UserUpdateInput;
};

export type UserUpdateMeMutation = {
  userUpdateMe?: boolean | null;
};

export type UserDeleteMutationVariables = {
  id: string;
};

export type UserDeleteMutation = {
  userDelete?: boolean | null;
};

export type UserUpdateHostDataMutationVariables = {
  input: UserUpdateHostDataInput;
};

export type UserUpdateHostDataMutation = {
  userUpdateHostData?: {
    __typename: 'User';
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    emailVerified: boolean;
    roles: Array<string | null>;
    hostTipsEnabled: boolean;
    hasHostedGame: boolean;
    organizationId?: string | null;
    username?: string | null;
    role?: RoleType | null;
    accountStatus?: OrganizationUserStatus | null;
    groupsCanRead?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UserCreateMutationVariables = {
  input: UserCreateInput;
};

export type UserCreateMutation = {
  userCreate?: {
    __typename: 'User';
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    emailVerified: boolean;
    roles: Array<string | null>;
    hostTipsEnabled: boolean;
    hasHostedGame: boolean;
    organizationId?: string | null;
    username?: string | null;
    role?: RoleType | null;
    accountStatus?: OrganizationUserStatus | null;
    groupsCanRead?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UserUpdateMutationVariables = {
  id: string;
  input: UserUpdateInput;
};

export type UserUpdateMutation = {
  userUpdate?: {
    __typename: 'User';
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    emailVerified: boolean;
    roles: Array<string | null>;
    hostTipsEnabled: boolean;
    hasHostedGame: boolean;
    organizationId?: string | null;
    username?: string | null;
    role?: RoleType | null;
    accountStatus?: OrganizationUserStatus | null;
    groupsCanRead?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UserUpdateStatusMutationVariables = {
  sub: string;
  input: UserUpdateInput;
};

export type UserUpdateStatusMutation = {
  userUpdateStatus?: {
    __typename: 'User';
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    emailVerified: boolean;
    roles: Array<string | null>;
    hostTipsEnabled: boolean;
    hasHostedGame: boolean;
    organizationId?: string | null;
    username?: string | null;
    role?: RoleType | null;
    accountStatus?: OrganizationUserStatus | null;
    groupsCanRead?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UserResendInviteMutationVariables = {
  email: string;
  isAdmin: boolean;
};

export type UserResendInviteMutation = {
  userResendInvite?: boolean | null;
};

export type SessionCreateMutationVariables = {
  input: SessionCreateInput;
};

export type SessionCreateMutation = {
  sessionCreate: {
    __typename: 'Session';
    id: string;
    hostId?: string | null;
    data: {
      __typename: 'SessionData';
      status: SessionStatus;
      players: Array<{
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }>;
      rounds: Array<{
        __typename: 'Round';
        id: string;
        index: number;
        isCurrent: boolean;
        isLast: boolean;
        promptId: string;
        artwork: Array<{
          __typename: 'Artwork';
          id: string;
          drawing: string;
          playerId: string;
        }>;
      }>;
      questionType: QuestionType;
    };
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  };
};

export type SessionNextRoundMutationVariables = {
  id: string;
};

export type SessionNextRoundMutation = {
  sessionNextRound?: {
    __typename: 'NewRoundUpdate';
    round: number;
    sessionStatus: SessionStatus;
    playerStatus: PlayerGameStatus;
  } | null;
};

export type SessionEndMutationVariables = {
  id: string;
};

export type SessionEndMutation = {
  sessionEnd?: {
    __typename: 'Session';
    id: string;
    hostId?: string | null;
    data: {
      __typename: 'SessionData';
      status: SessionStatus;
      players: Array<{
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }>;
      rounds: Array<{
        __typename: 'Round';
        id: string;
        index: number;
        isCurrent: boolean;
        isLast: boolean;
        promptId: string;
        artwork: Array<{
          __typename: 'Artwork';
          id: string;
          drawing: string;
          playerId: string;
        }>;
      }>;
      questionType: QuestionType;
    };
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type SessionSetEndingMutationVariables = {
  id: string;
};

export type SessionSetEndingMutation = {
  sessionSetEnding?: {
    __typename: 'Session';
    id: string;
    hostId?: string | null;
    data: {
      __typename: 'SessionData';
      status: SessionStatus;
      players: Array<{
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }>;
      rounds: Array<{
        __typename: 'Round';
        id: string;
        index: number;
        isCurrent: boolean;
        isLast: boolean;
        promptId: string;
        artwork: Array<{
          __typename: 'Artwork';
          id: string;
          drawing: string;
          playerId: string;
        }>;
      }>;
      questionType: QuestionType;
    };
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type SessionSetSharingMutationVariables = {
  id: string;
  playerId: string;
};

export type SessionSetSharingMutation = {
  sessionSetSharing?: {
    __typename: 'SharingPlayer';
    playerId: string;
  } | null;
};

export type PlayerJoinMutationVariables = {
  id: string;
  name: string;
  feelingBefore: number;
};

export type PlayerJoinMutation = {
  playerJoin: {
    __typename: 'NewPlayer';
    session: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    };
    newPlayer: {
      __typename: 'Player';
      id: string;
      name: string;
      gameStatus: PlayerGameStatus;
      connectionStatus: PlayerConnectionStatus;
      feelingBefore?: number | null;
      feelingAfter?: number | null;
      question?: string | null;
      questionAnswer?: boolean | null;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    };
  };
};

export type PlayerUpdateSentimentMutationVariables = {
  id: string;
  playerId: string;
  sentiment: number;
  isBefore: boolean;
};

export type PlayerUpdateSentimentMutation = {
  playerUpdateSentiment?: {
    __typename: 'Session';
    id: string;
    hostId?: string | null;
    data: {
      __typename: 'SessionData';
      status: SessionStatus;
      players: Array<{
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }>;
      rounds: Array<{
        __typename: 'Round';
        id: string;
        index: number;
        isCurrent: boolean;
        isLast: boolean;
        promptId: string;
        artwork: Array<{
          __typename: 'Artwork';
          id: string;
          drawing: string;
          playerId: string;
        }>;
      }>;
      questionType: QuestionType;
    };
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type PlayerUpdateQuestionMutationVariables = {
  id: string;
  playerId: string;
  question: string;
  answer: boolean;
};

export type PlayerUpdateQuestionMutation = {
  playerUpdateQuestion?: {
    __typename: 'Session';
    id: string;
    hostId?: string | null;
    data: {
      __typename: 'SessionData';
      status: SessionStatus;
      players: Array<{
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }>;
      rounds: Array<{
        __typename: 'Round';
        id: string;
        index: number;
        isCurrent: boolean;
        isLast: boolean;
        promptId: string;
        artwork: Array<{
          __typename: 'Artwork';
          id: string;
          drawing: string;
          playerId: string;
        }>;
      }>;
      questionType: QuestionType;
    };
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type PlayerSubmitDrawingMutationVariables = {
  id: string;
  playerId: string;
  drawing: string;
};

export type PlayerSubmitDrawingMutation = {
  playerSubmitDrawing?: {
    __typename: 'Artwork';
    id: string;
    drawing: string;
    playerId: string;
  } | null;
};

export type PlayerReactMutationVariables = {
  id: string;
  playerId: string;
  artworkId: string;
  reaction: string;
};

export type PlayerReactMutation = {
  playerReact?: {
    __typename: 'Session';
    id: string;
    hostId?: string | null;
    data: {
      __typename: 'SessionData';
      status: SessionStatus;
      players: Array<{
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }>;
      rounds: Array<{
        __typename: 'Round';
        id: string;
        index: number;
        isCurrent: boolean;
        isLast: boolean;
        promptId: string;
        artwork: Array<{
          __typename: 'Artwork';
          id: string;
          drawing: string;
          playerId: string;
        }>;
      }>;
      questionType: QuestionType;
    };
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type GamePackCreateMutationVariables = {
  name: string;
  description: string;
  icon: GamePackIcon;
  palette: GamePackPalette;
  category1?: string | null;
  category2?: string | null;
  category3?: string | null;
  isFeatured?: boolean | null;
  showInDiscover?: boolean | null;
  isNew?: boolean | null;
  groups?: Array<string> | null;
  status?: GamePackStatus | null;
  organizationIds?: Array<string> | null;
};

export type GamePackCreateMutation = {
  gamePackCreate?: {
    __typename: 'GamePack';
    id: string;
    name: string;
    description: string;
    category1?: string | null;
    category2?: string | null;
    category3?: string | null;
    icon: GamePackIcon;
    palette: GamePackPalette;
    isFeatured: boolean;
    showInDiscover: boolean;
    isNew: boolean;
    order: number;
    groups?: Array<string> | null;
    status: GamePackStatus;
    prompts?: Array<{
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    organizations?: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackUpdateMutationVariables = {
  id: string;
  name: string;
  description: string;
  icon: GamePackIcon;
  palette: GamePackPalette;
  category1?: string | null;
  category2?: string | null;
  category3?: string | null;
  isFeatured?: boolean | null;
  showInDiscover?: boolean | null;
  isNew?: boolean | null;
  groups?: Array<string> | null;
  status?: GamePackStatus | null;
  organizationIds?: Array<string> | null;
};

export type GamePackUpdateMutation = {
  gamePackUpdate?: {
    __typename: 'GamePack';
    id: string;
    name: string;
    description: string;
    category1?: string | null;
    category2?: string | null;
    category3?: string | null;
    icon: GamePackIcon;
    palette: GamePackPalette;
    isFeatured: boolean;
    showInDiscover: boolean;
    isNew: boolean;
    order: number;
    groups?: Array<string> | null;
    status: GamePackStatus;
    prompts?: Array<{
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    organizations?: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackUpdateOrderMutationVariables = {
  orders: Array<GamePackOrderInput>;
};

export type GamePackUpdateOrderMutation = {
  gamePackUpdateOrder: Array<{
    __typename: 'GamePack';
    id: string;
    name: string;
    description: string;
    category1?: string | null;
    category2?: string | null;
    category3?: string | null;
    icon: GamePackIcon;
    palette: GamePackPalette;
    isFeatured: boolean;
    showInDiscover: boolean;
    isNew: boolean;
    order: number;
    groups?: Array<string> | null;
    status: GamePackStatus;
    prompts?: Array<{
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    organizations?: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GamePackAddPromptMutationVariables = {
  id: string;
  promptId: string;
};

export type GamePackAddPromptMutation = {
  gamePackAddPrompt?: {
    __typename: 'GamePack';
    id: string;
    name: string;
    description: string;
    category1?: string | null;
    category2?: string | null;
    category3?: string | null;
    icon: GamePackIcon;
    palette: GamePackPalette;
    isFeatured: boolean;
    showInDiscover: boolean;
    isNew: boolean;
    order: number;
    groups?: Array<string> | null;
    status: GamePackStatus;
    prompts?: Array<{
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    organizations?: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackRemovePromptMutationVariables = {
  id: string;
  promptId: string;
};

export type GamePackRemovePromptMutation = {
  gamePackRemovePrompt?: {
    __typename: 'GamePack';
    id: string;
    name: string;
    description: string;
    category1?: string | null;
    category2?: string | null;
    category3?: string | null;
    icon: GamePackIcon;
    palette: GamePackPalette;
    isFeatured: boolean;
    showInDiscover: boolean;
    isNew: boolean;
    order: number;
    groups?: Array<string> | null;
    status: GamePackStatus;
    prompts?: Array<{
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    organizations?: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackDeleteMutationVariables = {
  id: string;
};

export type GamePackDeleteMutation = {
  gamePackDelete?: {
    __typename: 'GamePack';
    id: string;
    name: string;
    description: string;
    category1?: string | null;
    category2?: string | null;
    category3?: string | null;
    icon: GamePackIcon;
    palette: GamePackPalette;
    isFeatured: boolean;
    showInDiscover: boolean;
    isNew: boolean;
    order: number;
    groups?: Array<string> | null;
    status: GamePackStatus;
    prompts?: Array<{
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    organizations?: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PromptCreateMutationVariables = {
  text: string;
  subdomain?: string | null;
};

export type PromptCreateMutation = {
  promptCreate?: {
    __typename: 'Prompt';
    id: string;
    text: string;
    subdomain?: string | null;
    deletedAt?: string | null;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PromptUpdateMutationVariables = {
  id: string;
  text: string;
  subdomain?: string | null;
};

export type PromptUpdateMutation = {
  promptUpdate?: {
    __typename: 'Prompt';
    id: string;
    text: string;
    subdomain?: string | null;
    deletedAt?: string | null;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PromptDeleteMutationVariables = {
  id: string;
};

export type PromptDeleteMutation = {
  promptDelete?: {
    __typename: 'Prompt';
    id: string;
    text: string;
    subdomain?: string | null;
    deletedAt?: string | null;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OrganizationCreateMutationVariables = {
  input: OrganizationCreateInput;
};

export type OrganizationCreateMutation = {
  organizationCreate?: {
    __typename: 'Organization';
    id: string;
    name: string;
    tenant: string;
    subdomain: string;
    emailDomains: Array<string>;
    groupsCanRead?: Array<string> | null;
    organizationActive?: boolean | null;
    hostLicenses: number;
    adminLicenses: number;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    activeUsers?: number | null;
    activeHosts?: number | null;
    activeAdmins?: number | null;
    onFreeTrial: boolean;
    freeTrialExpiration?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OrganizationUpdateMutationVariables = {
  id: string;
  input: OrganizationUpdateInput;
};

export type OrganizationUpdateMutation = {
  organizationUpdate?: {
    __typename: 'Organization';
    id: string;
    name: string;
    tenant: string;
    subdomain: string;
    emailDomains: Array<string>;
    groupsCanRead?: Array<string> | null;
    organizationActive?: boolean | null;
    hostLicenses: number;
    adminLicenses: number;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    activeUsers?: number | null;
    activeHosts?: number | null;
    activeAdmins?: number | null;
    onFreeTrial: boolean;
    freeTrialExpiration?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OrganizationDeleteMutationVariables = {
  id: string;
};

export type OrganizationDeleteMutation = {
  organizationDelete?: {
    __typename: 'Organization';
    id: string;
    name: string;
    tenant: string;
    subdomain: string;
    emailDomains: Array<string>;
    groupsCanRead?: Array<string> | null;
    organizationActive?: boolean | null;
    hostLicenses: number;
    adminLicenses: number;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    activeUsers?: number | null;
    activeHosts?: number | null;
    activeAdmins?: number | null;
    onFreeTrial: boolean;
    freeTrialExpiration?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OrganizationAddUserMutationVariables = {
  organizationId: string;
  userId: string;
};

export type OrganizationAddUserMutation = {
  organizationAddUser?: {
    __typename: 'Organization';
    id: string;
    name: string;
    tenant: string;
    subdomain: string;
    emailDomains: Array<string>;
    groupsCanRead?: Array<string> | null;
    organizationActive?: boolean | null;
    hostLicenses: number;
    adminLicenses: number;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    activeUsers?: number | null;
    activeHosts?: number | null;
    activeAdmins?: number | null;
    onFreeTrial: boolean;
    freeTrialExpiration?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OrganizationInviteUserMutationVariables = {
  input: UserInviteInput;
};

export type OrganizationInviteUserMutation = {
  organizationInviteUser?: {
    __typename: 'User';
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    emailVerified: boolean;
    roles: Array<string | null>;
    hostTipsEnabled: boolean;
    hasHostedGame: boolean;
    organizationId?: string | null;
    username?: string | null;
    role?: RoleType | null;
    accountStatus?: OrganizationUserStatus | null;
    groupsCanRead?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PlayerCreateMutationVariables = {
  input: PlayerCreateInput;
};

export type PlayerCreateMutation = {
  playerCreate?: {
    __typename: 'Player';
    id: string;
    name: string;
    gameStatus: PlayerGameStatus;
    connectionStatus: PlayerConnectionStatus;
    feelingBefore?: number | null;
    feelingAfter?: number | null;
    question?: string | null;
    questionAnswer?: boolean | null;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type PlayerUpdateMutationVariables = {
  id: string;
  input: PlayerUpdateInput;
};

export type PlayerUpdateMutation = {
  playerUpdate?: {
    __typename: 'Player';
    id: string;
    name: string;
    gameStatus: PlayerGameStatus;
    connectionStatus: PlayerConnectionStatus;
    feelingBefore?: number | null;
    feelingAfter?: number | null;
    question?: string | null;
    questionAnswer?: boolean | null;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type PlayerDeleteMutationVariables = {
  id: string;
};

export type PlayerDeleteMutation = {
  playerDelete?: boolean | null;
};

export type PlayerUpdateConnectionStatusMutationVariables = {
  id: string;
  connectionStatus: PlayerConnectionStatus;
};

export type PlayerUpdateConnectionStatusMutation = {
  playerUpdateConnectionStatus?: {
    __typename: 'Player';
    id: string;
    name: string;
    gameStatus: PlayerGameStatus;
    connectionStatus: PlayerConnectionStatus;
    feelingBefore?: number | null;
    feelingAfter?: number | null;
    question?: string | null;
    questionAnswer?: boolean | null;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type PlayerUpdateGameStatusMutationVariables = {
  id: string;
  gameStatus: PlayerGameStatus;
};

export type PlayerUpdateGameStatusMutation = {
  playerUpdateGameStatus?: {
    __typename: 'Player';
    id: string;
    name: string;
    gameStatus: PlayerGameStatus;
    connectionStatus: PlayerConnectionStatus;
    feelingBefore?: number | null;
    feelingAfter?: number | null;
    question?: string | null;
    questionAnswer?: boolean | null;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type GameCreateMutationVariables = {
  input: GameCreateInput;
};

export type GameCreateMutation = {
  gameCreate?: {
    __typename: 'Game';
    id: string;
    promptText: string;
    promptGamePackId?: string | null;
    status: GameStatus;
    gameIndex: number;
    isCurrent: boolean;
    isLast: boolean;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GameUpdateMutationVariables = {
  id: string;
  input: GameUpdateInput;
};

export type GameUpdateMutation = {
  gameUpdate?: {
    __typename: 'Game';
    id: string;
    promptText: string;
    promptGamePackId?: string | null;
    status: GameStatus;
    gameIndex: number;
    isCurrent: boolean;
    isLast: boolean;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GameDeleteMutationVariables = {
  id: string;
};

export type GameDeleteMutation = {
  gameDelete?: boolean | null;
};

export type GameUpdateStatusMutationVariables = {
  id: string;
  status: GameStatus;
};

export type GameUpdateStatusMutation = {
  gameUpdateStatus?: {
    __typename: 'Game';
    id: string;
    promptText: string;
    promptGamePackId?: string | null;
    status: GameStatus;
    gameIndex: number;
    isCurrent: boolean;
    isLast: boolean;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GameSetCurrentMutationVariables = {
  id: string;
};

export type GameSetCurrentMutation = {
  gameSetCurrent?: {
    __typename: 'Game';
    id: string;
    promptText: string;
    promptGamePackId?: string | null;
    status: GameStatus;
    gameIndex: number;
    isCurrent: boolean;
    isLast: boolean;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GameSetLastMutationVariables = {
  id: string;
};

export type GameSetLastMutation = {
  gameSetLast?: {
    __typename: 'Game';
    id: string;
    promptText: string;
    promptGamePackId?: string | null;
    status: GameStatus;
    gameIndex: number;
    isCurrent: boolean;
    isLast: boolean;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PlayerCardCreateMutationVariables = {
  input: PlayerCardCreateInput;
};

export type PlayerCardCreateMutation = {
  playerCardCreate?: {
    __typename: 'PlayerCard';
    id: string;
    drawing?: string | null;
    drawingLines?: string | null;
    timesStoryMadeFeelGood: number;
    timesStoryWasRelated: number;
    timesStoryWasShared: number;
    gameId: string;
    playerId: string;
    sessionId: string;
    game?: {
      __typename: 'Game';
      id: string;
      promptText: string;
      promptGamePackId?: string | null;
      status: GameStatus;
      gameIndex: number;
      isCurrent: boolean;
      isLast: boolean;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    player?: {
      __typename: 'Player';
      id: string;
      name: string;
      gameStatus: PlayerGameStatus;
      connectionStatus: PlayerConnectionStatus;
      feelingBefore?: number | null;
      feelingAfter?: number | null;
      question?: string | null;
      questionAnswer?: boolean | null;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    artworkReactions: Array<{
      __typename: 'ArtworkReaction';
      id: string;
      reaction: number;
      playerCardId: string;
      playerId: string;
      sessionId: string;
      playerCard?: {
        __typename: 'PlayerCard';
        id: string;
        drawing?: string | null;
        drawingLines?: string | null;
        timesStoryMadeFeelGood: number;
        timesStoryWasRelated: number;
        timesStoryWasShared: number;
        gameId: string;
        playerId: string;
        sessionId: string;
        game?: {
          __typename: 'Game';
          id: string;
          promptText: string;
          promptGamePackId?: string | null;
          status: GameStatus;
          gameIndex: number;
          isCurrent: boolean;
          isLast: boolean;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        player?: {
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        artworkReactions: Array<{
          __typename: 'ArtworkReaction';
          id: string;
          reaction: number;
          playerCardId: string;
          playerId: string;
          sessionId: string;
          playerCard?: {
            __typename: 'PlayerCard';
            id: string;
            drawing?: string | null;
            drawingLines?: string | null;
            timesStoryMadeFeelGood: number;
            timesStoryWasRelated: number;
            timesStoryWasShared: number;
            gameId: string;
            playerId: string;
            sessionId: string;
            createdAt: string;
            updatedAt: string;
          } | null;
          player?: {
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
        }>;
        createdAt: string;
        updatedAt: string;
      } | null;
      player?: {
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
    }>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PlayerCardUpdateMutationVariables = {
  id: string;
  input: PlayerCardUpdateInput;
};

export type PlayerCardUpdateMutation = {
  playerCardUpdate?: {
    __typename: 'PlayerCard';
    id: string;
    drawing?: string | null;
    drawingLines?: string | null;
    timesStoryMadeFeelGood: number;
    timesStoryWasRelated: number;
    timesStoryWasShared: number;
    gameId: string;
    playerId: string;
    sessionId: string;
    game?: {
      __typename: 'Game';
      id: string;
      promptText: string;
      promptGamePackId?: string | null;
      status: GameStatus;
      gameIndex: number;
      isCurrent: boolean;
      isLast: boolean;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    player?: {
      __typename: 'Player';
      id: string;
      name: string;
      gameStatus: PlayerGameStatus;
      connectionStatus: PlayerConnectionStatus;
      feelingBefore?: number | null;
      feelingAfter?: number | null;
      question?: string | null;
      questionAnswer?: boolean | null;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    artworkReactions: Array<{
      __typename: 'ArtworkReaction';
      id: string;
      reaction: number;
      playerCardId: string;
      playerId: string;
      sessionId: string;
      playerCard?: {
        __typename: 'PlayerCard';
        id: string;
        drawing?: string | null;
        drawingLines?: string | null;
        timesStoryMadeFeelGood: number;
        timesStoryWasRelated: number;
        timesStoryWasShared: number;
        gameId: string;
        playerId: string;
        sessionId: string;
        game?: {
          __typename: 'Game';
          id: string;
          promptText: string;
          promptGamePackId?: string | null;
          status: GameStatus;
          gameIndex: number;
          isCurrent: boolean;
          isLast: boolean;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        player?: {
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        artworkReactions: Array<{
          __typename: 'ArtworkReaction';
          id: string;
          reaction: number;
          playerCardId: string;
          playerId: string;
          sessionId: string;
          playerCard?: {
            __typename: 'PlayerCard';
            id: string;
            drawing?: string | null;
            drawingLines?: string | null;
            timesStoryMadeFeelGood: number;
            timesStoryWasRelated: number;
            timesStoryWasShared: number;
            gameId: string;
            playerId: string;
            sessionId: string;
            createdAt: string;
            updatedAt: string;
          } | null;
          player?: {
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
        }>;
        createdAt: string;
        updatedAt: string;
      } | null;
      player?: {
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
    }>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PlayerCardDeleteMutationVariables = {
  id: string;
};

export type PlayerCardDeleteMutation = {
  playerCardDelete?: boolean | null;
};

export type PlayerCardUpdateDrawingMutationVariables = {
  id: string;
  drawing: string;
  drawingLines?: string | null;
};

export type PlayerCardUpdateDrawingMutation = {
  playerCardUpdateDrawing?: {
    __typename: 'PlayerCard';
    id: string;
    drawing?: string | null;
    drawingLines?: string | null;
    timesStoryMadeFeelGood: number;
    timesStoryWasRelated: number;
    timesStoryWasShared: number;
    gameId: string;
    playerId: string;
    sessionId: string;
    game?: {
      __typename: 'Game';
      id: string;
      promptText: string;
      promptGamePackId?: string | null;
      status: GameStatus;
      gameIndex: number;
      isCurrent: boolean;
      isLast: boolean;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    player?: {
      __typename: 'Player';
      id: string;
      name: string;
      gameStatus: PlayerGameStatus;
      connectionStatus: PlayerConnectionStatus;
      feelingBefore?: number | null;
      feelingAfter?: number | null;
      question?: string | null;
      questionAnswer?: boolean | null;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    artworkReactions: Array<{
      __typename: 'ArtworkReaction';
      id: string;
      reaction: number;
      playerCardId: string;
      playerId: string;
      sessionId: string;
      playerCard?: {
        __typename: 'PlayerCard';
        id: string;
        drawing?: string | null;
        drawingLines?: string | null;
        timesStoryMadeFeelGood: number;
        timesStoryWasRelated: number;
        timesStoryWasShared: number;
        gameId: string;
        playerId: string;
        sessionId: string;
        game?: {
          __typename: 'Game';
          id: string;
          promptText: string;
          promptGamePackId?: string | null;
          status: GameStatus;
          gameIndex: number;
          isCurrent: boolean;
          isLast: boolean;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        player?: {
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        artworkReactions: Array<{
          __typename: 'ArtworkReaction';
          id: string;
          reaction: number;
          playerCardId: string;
          playerId: string;
          sessionId: string;
          playerCard?: {
            __typename: 'PlayerCard';
            id: string;
            drawing?: string | null;
            drawingLines?: string | null;
            timesStoryMadeFeelGood: number;
            timesStoryWasRelated: number;
            timesStoryWasShared: number;
            gameId: string;
            playerId: string;
            sessionId: string;
            createdAt: string;
            updatedAt: string;
          } | null;
          player?: {
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
        }>;
        createdAt: string;
        updatedAt: string;
      } | null;
      player?: {
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
    }>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PlayerCardIncrementReactionMutationVariables = {
  id: string;
  type: ReactionType;
};

export type PlayerCardIncrementReactionMutation = {
  playerCardIncrementReaction?: {
    __typename: 'PlayerCard';
    id: string;
    drawing?: string | null;
    drawingLines?: string | null;
    timesStoryMadeFeelGood: number;
    timesStoryWasRelated: number;
    timesStoryWasShared: number;
    gameId: string;
    playerId: string;
    sessionId: string;
    game?: {
      __typename: 'Game';
      id: string;
      promptText: string;
      promptGamePackId?: string | null;
      status: GameStatus;
      gameIndex: number;
      isCurrent: boolean;
      isLast: boolean;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    player?: {
      __typename: 'Player';
      id: string;
      name: string;
      gameStatus: PlayerGameStatus;
      connectionStatus: PlayerConnectionStatus;
      feelingBefore?: number | null;
      feelingAfter?: number | null;
      question?: string | null;
      questionAnswer?: boolean | null;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    artworkReactions: Array<{
      __typename: 'ArtworkReaction';
      id: string;
      reaction: number;
      playerCardId: string;
      playerId: string;
      sessionId: string;
      playerCard?: {
        __typename: 'PlayerCard';
        id: string;
        drawing?: string | null;
        drawingLines?: string | null;
        timesStoryMadeFeelGood: number;
        timesStoryWasRelated: number;
        timesStoryWasShared: number;
        gameId: string;
        playerId: string;
        sessionId: string;
        game?: {
          __typename: 'Game';
          id: string;
          promptText: string;
          promptGamePackId?: string | null;
          status: GameStatus;
          gameIndex: number;
          isCurrent: boolean;
          isLast: boolean;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        player?: {
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        artworkReactions: Array<{
          __typename: 'ArtworkReaction';
          id: string;
          reaction: number;
          playerCardId: string;
          playerId: string;
          sessionId: string;
          playerCard?: {
            __typename: 'PlayerCard';
            id: string;
            drawing?: string | null;
            drawingLines?: string | null;
            timesStoryMadeFeelGood: number;
            timesStoryWasRelated: number;
            timesStoryWasShared: number;
            gameId: string;
            playerId: string;
            sessionId: string;
            createdAt: string;
            updatedAt: string;
          } | null;
          player?: {
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
        }>;
        createdAt: string;
        updatedAt: string;
      } | null;
      player?: {
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
    }>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackPromptsCreateMutationVariables = {
  input: GamePackPromptsCreateInput;
};

export type GamePackPromptsCreateMutation = {
  gamePackPromptsCreate?: {
    __typename: 'GamePackPrompts';
    id: string;
    promptId: string;
    gamePackId: string;
    prompt: {
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackPromptsUpdateMutationVariables = {
  id: string;
  input: GamePackPromptsUpdateInput;
};

export type GamePackPromptsUpdateMutation = {
  gamePackPromptsUpdate?: {
    __typename: 'GamePackPrompts';
    id: string;
    promptId: string;
    gamePackId: string;
    prompt: {
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackPromptsDeleteMutationVariables = {
  id: string;
};

export type GamePackPromptsDeleteMutation = {
  gamePackPromptsDelete?: boolean | null;
};

export type GamePackOrganizationsCreateMutationVariables = {
  input: GamePackOrganizationsCreateInput;
};

export type GamePackOrganizationsCreateMutation = {
  gamePackOrganizationsCreate?: {
    __typename: 'GamePackOrganizations';
    id: string;
    gamePackId: string;
    organizationId: string;
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    organization: {
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackOrganizationsUpdateMutationVariables = {
  id: string;
  input: GamePackOrganizationsUpdateInput;
};

export type GamePackOrganizationsUpdateMutation = {
  gamePackOrganizationsUpdate?: {
    __typename: 'GamePackOrganizations';
    id: string;
    gamePackId: string;
    organizationId: string;
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    organization: {
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackOrganizationsDeleteMutationVariables = {
  id: string;
};

export type GamePackOrganizationsDeleteMutation = {
  gamePackOrganizationsDelete?: boolean | null;
};

export type ArtworkReactionCreateMutationVariables = {
  input: ArtworkReactionCreateInput;
};

export type ArtworkReactionCreateMutation = {
  artworkReactionCreate?: {
    __typename: 'RedisArtworkReaction';
    reaction: number;
    playerCardId: string;
    playerId: string;
    sessionId: string;
  } | null;
};

export type StartAsyncTaskMutationVariables = {
  input: AsyncTaskInput;
};

export type StartAsyncTaskMutation = {
  startAsyncTask: {
    __typename: 'AsyncTask';
    id: string;
    type: string;
    status: AsyncTaskStatus;
    payload?: string | null;
    result?: string | null;
    error?: string | null;
    createdBy?: string | null;
    tenant?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  };
};

export type ListOrganizationUsersFilteredLiteQueryVariables = {
  filter?: OrganizationUserFilter | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListOrganizationUsersFilteredLiteQuery = {
  listOrganizationUsersFiltered: {
    __typename: 'UserConnection';
    items: Array<{
      __typename: 'User';
      id: string;
      email: string;
      roles: Array<string | null>;
      organizationId?: string | null;
      username?: string | null;
      role?: RoleType | null;
      accountStatus?: OrganizationUserStatus | null;
      groupsCanRead?: Array<string> | null;
      createdAt: string;
      updatedAt: string;
    }>;
    nextToken?: string | null;
  };
};

export type UserGetMeQueryVariables = {};

export type UserGetMeQuery = {
  userGetMe?: {
    __typename: 'User';
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    emailVerified: boolean;
    roles: Array<string | null>;
    hostTipsEnabled: boolean;
    hasHostedGame: boolean;
    organizationId?: string | null;
    username?: string | null;
    role?: RoleType | null;
    accountStatus?: OrganizationUserStatus | null;
    groupsCanRead?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UserGetQueryVariables = {
  id: string;
};

export type UserGetQuery = {
  userGet?: {
    __typename: 'User';
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    emailVerified: boolean;
    roles: Array<string | null>;
    hostTipsEnabled: boolean;
    hasHostedGame: boolean;
    organizationId?: string | null;
    username?: string | null;
    role?: RoleType | null;
    accountStatus?: OrganizationUserStatus | null;
    groupsCanRead?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type UserListQueryVariables = {};

export type UserListQuery = {
  userList: Array<{
    __typename: 'User';
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    emailVerified: boolean;
    roles: Array<string | null>;
    hostTipsEnabled: boolean;
    hasHostedGame: boolean;
    organizationId?: string | null;
    username?: string | null;
    role?: RoleType | null;
    accountStatus?: OrganizationUserStatus | null;
    groupsCanRead?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
};

export type UserListByOrganizationQueryVariables = {
  organizationId: string;
};

export type UserListByOrganizationQuery = {
  userListByOrganization: Array<{
    __typename: 'User';
    id: string;
    givenName: string;
    familyName: string;
    email: string;
    emailVerified: boolean;
    roles: Array<string | null>;
    hostTipsEnabled: boolean;
    hasHostedGame: boolean;
    organizationId?: string | null;
    username?: string | null;
    role?: RoleType | null;
    accountStatus?: OrganizationUserStatus | null;
    groupsCanRead?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
};

export type ListOrganizationUsersFilteredQueryVariables = {
  filter?: OrganizationUserFilter | null;
  limit?: number | null;
  nextToken?: string | null;
};

export type ListOrganizationUsersFilteredQuery = {
  listOrganizationUsersFiltered: {
    __typename: 'UserConnection';
    items: Array<{
      __typename: 'User';
      id: string;
      givenName: string;
      familyName: string;
      email: string;
      emailVerified: boolean;
      roles: Array<string | null>;
      hostTipsEnabled: boolean;
      hasHostedGame: boolean;
      organizationId?: string | null;
      username?: string | null;
      role?: RoleType | null;
      accountStatus?: OrganizationUserStatus | null;
      groupsCanRead?: Array<string> | null;
      createdAt: string;
      updatedAt: string;
    }>;
    nextToken?: string | null;
  };
};

export type UserCountByOrganizationQueryVariables = {
  organizationId: string;
};

export type UserCountByOrganizationQuery = {
  userCountByOrganization: {
    __typename: 'OrganizationUserRoleCounts';
    adminCount: number;
    hostCount: number;
  };
};

export type UserCountByOrganizationAndRoleQueryVariables = {
  organizationId: string;
  role: RoleType;
};

export type UserCountByOrganizationAndRoleQuery = {
  userCountByOrganizationAndRole: number;
};

export type UserCountsByOrganizationQueryVariables = {
  organizationIds: Array<string>;
};

export type UserCountsByOrganizationQuery = {
  userCountsByOrganization: Array<{
    __typename: 'OrganizationUserCount';
    organizationId: string;
    count: number;
  }>;
};

export type SessionGetQueryVariables = {
  id: string;
};

export type SessionGetQuery = {
  sessionGet?: {
    __typename: 'Session';
    id: string;
    hostId?: string | null;
    data: {
      __typename: 'SessionData';
      status: SessionStatus;
      players: Array<{
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }>;
      rounds: Array<{
        __typename: 'Round';
        id: string;
        index: number;
        isCurrent: boolean;
        isLast: boolean;
        promptId: string;
        artwork: Array<{
          __typename: 'Artwork';
          id: string;
          drawing: string;
          playerId: string;
        }>;
      }>;
      questionType: QuestionType;
    };
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type SessionListQueryVariables = {};

export type SessionListQuery = {
  sessionList: Array<{
    __typename: 'Session';
    id: string;
    hostId?: string | null;
    data: {
      __typename: 'SessionData';
      status: SessionStatus;
      players: Array<{
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }>;
      rounds: Array<{
        __typename: 'Round';
        id: string;
        index: number;
        isCurrent: boolean;
        isLast: boolean;
        promptId: string;
        artwork: Array<{
          __typename: 'Artwork';
          id: string;
          drawing: string;
          playerId: string;
        }>;
      }>;
      questionType: QuestionType;
    };
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null>;
};

export type GamePackGetQueryVariables = {
  id: string;
};

export type GamePackGetQuery = {
  gamePackGet?: {
    __typename: 'GamePack';
    id: string;
    name: string;
    description: string;
    category1?: string | null;
    category2?: string | null;
    category3?: string | null;
    icon: GamePackIcon;
    palette: GamePackPalette;
    isFeatured: boolean;
    showInDiscover: boolean;
    isNew: boolean;
    order: number;
    groups?: Array<string> | null;
    status: GamePackStatus;
    prompts?: Array<{
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    organizations?: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackListQueryVariables = {};

export type GamePackListQuery = {
  gamePackList: Array<{
    __typename: 'GamePack';
    id: string;
    name: string;
    description: string;
    category1?: string | null;
    category2?: string | null;
    category3?: string | null;
    icon: GamePackIcon;
    palette: GamePackPalette;
    isFeatured: boolean;
    showInDiscover: boolean;
    isNew: boolean;
    order: number;
    groups?: Array<string> | null;
    status: GamePackStatus;
    prompts?: Array<{
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    organizations?: Array<{
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type PromptGetQueryVariables = {
  id: string;
};

export type PromptGetQuery = {
  promptGet?: {
    __typename: 'Prompt';
    id: string;
    text: string;
    subdomain?: string | null;
    deletedAt?: string | null;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PromptListQueryVariables = {};

export type PromptListQuery = {
  promptList: Array<{
    __typename: 'Prompt';
    id: string;
    text: string;
    subdomain?: string | null;
    deletedAt?: string | null;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackPrompts?: Array<{
      __typename: 'GamePackPrompts';
      id: string;
      promptId: string;
      gamePackId: string;
      prompt: {
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type OrganizationGetMeQueryVariables = {};

export type OrganizationGetMeQuery = {
  organizationGetMe?: {
    __typename: 'Organization';
    id: string;
    name: string;
    tenant: string;
    subdomain: string;
    emailDomains: Array<string>;
    groupsCanRead?: Array<string> | null;
    organizationActive?: boolean | null;
    hostLicenses: number;
    adminLicenses: number;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    activeUsers?: number | null;
    activeHosts?: number | null;
    activeAdmins?: number | null;
    onFreeTrial: boolean;
    freeTrialExpiration?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OrganizationGetQueryVariables = {
  id: string;
};

export type OrganizationGetQuery = {
  organizationGet?: {
    __typename: 'Organization';
    id: string;
    name: string;
    tenant: string;
    subdomain: string;
    emailDomains: Array<string>;
    groupsCanRead?: Array<string> | null;
    organizationActive?: boolean | null;
    hostLicenses: number;
    adminLicenses: number;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    activeUsers?: number | null;
    activeHosts?: number | null;
    activeAdmins?: number | null;
    onFreeTrial: boolean;
    freeTrialExpiration?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OrganizationGetByTenantQueryVariables = {
  tenant: string;
};

export type OrganizationGetByTenantQuery = {
  organizationGetByTenant?: {
    __typename: 'Organization';
    id: string;
    name: string;
    tenant: string;
    subdomain: string;
    emailDomains: Array<string>;
    groupsCanRead?: Array<string> | null;
    organizationActive?: boolean | null;
    hostLicenses: number;
    adminLicenses: number;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    activeUsers?: number | null;
    activeHosts?: number | null;
    activeAdmins?: number | null;
    onFreeTrial: boolean;
    freeTrialExpiration?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OrganizationGetByNameQueryVariables = {
  name: string;
};

export type OrganizationGetByNameQuery = {
  organizationGetByName?: {
    __typename: 'Organization';
    id: string;
    name: string;
    tenant: string;
    subdomain: string;
    emailDomains: Array<string>;
    groupsCanRead?: Array<string> | null;
    organizationActive?: boolean | null;
    hostLicenses: number;
    adminLicenses: number;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    activeUsers?: number | null;
    activeHosts?: number | null;
    activeAdmins?: number | null;
    onFreeTrial: boolean;
    freeTrialExpiration?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type OrganizationListQueryVariables = {};

export type OrganizationListQuery = {
  organizationList: Array<{
    __typename: 'Organization';
    id: string;
    name: string;
    tenant: string;
    subdomain: string;
    emailDomains: Array<string>;
    groupsCanRead?: Array<string> | null;
    organizationActive?: boolean | null;
    hostLicenses: number;
    adminLicenses: number;
    gamePacks?: Array<{
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    }> | null;
    gamePackOrganizations?: Array<{
      __typename: 'GamePackOrganizations';
      id: string;
      gamePackId: string;
      organizationId: string;
      gamePack: {
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      };
      organization: {
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      };
      createdAt: string;
      updatedAt: string;
    }> | null;
    activeUsers?: number | null;
    activeHosts?: number | null;
    activeAdmins?: number | null;
    onFreeTrial: boolean;
    freeTrialExpiration?: string | null;
    createdAt: string;
    updatedAt: string;
  } | null>;
};

export type OrganizationPublicListQueryVariables = {};

export type OrganizationPublicListQuery = {
  organizationPublicList: Array<{
    __typename: 'OrganizationPublic';
    id: string;
    name: string;
    subdomain: string;
    tenant: string;
  } | null>;
};

export type PlayerGetQueryVariables = {
  id: string;
};

export type PlayerGetQuery = {
  playerGet?: {
    __typename: 'Player';
    id: string;
    name: string;
    gameStatus: PlayerGameStatus;
    connectionStatus: PlayerConnectionStatus;
    feelingBefore?: number | null;
    feelingAfter?: number | null;
    question?: string | null;
    questionAnswer?: boolean | null;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type PlayerListQueryVariables = {
  sessionId: string;
};

export type PlayerListQuery = {
  playerList: Array<{
    __typename: 'Player';
    id: string;
    name: string;
    gameStatus: PlayerGameStatus;
    connectionStatus: PlayerConnectionStatus;
    feelingBefore?: number | null;
    feelingAfter?: number | null;
    question?: string | null;
    questionAnswer?: boolean | null;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  }>;
};

export type GameGetQueryVariables = {
  id: string;
};

export type GameGetQuery = {
  gameGet?: {
    __typename: 'Game';
    id: string;
    promptText: string;
    promptGamePackId?: string | null;
    status: GameStatus;
    gameIndex: number;
    isCurrent: boolean;
    isLast: boolean;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GameListQueryVariables = {
  sessionId: string;
};

export type GameListQuery = {
  gameList: Array<{
    __typename: 'Game';
    id: string;
    promptText: string;
    promptGamePackId?: string | null;
    status: GameStatus;
    gameIndex: number;
    isCurrent: boolean;
    isLast: boolean;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GameGetCurrentQueryVariables = {
  sessionId: string;
};

export type GameGetCurrentQuery = {
  gameGetCurrent?: {
    __typename: 'Game';
    id: string;
    promptText: string;
    promptGamePackId?: string | null;
    status: GameStatus;
    gameIndex: number;
    isCurrent: boolean;
    isLast: boolean;
    sessionId: string;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PlayerCardGetQueryVariables = {
  id: string;
};

export type PlayerCardGetQuery = {
  playerCardGet?: {
    __typename: 'PlayerCard';
    id: string;
    drawing?: string | null;
    drawingLines?: string | null;
    timesStoryMadeFeelGood: number;
    timesStoryWasRelated: number;
    timesStoryWasShared: number;
    gameId: string;
    playerId: string;
    sessionId: string;
    game?: {
      __typename: 'Game';
      id: string;
      promptText: string;
      promptGamePackId?: string | null;
      status: GameStatus;
      gameIndex: number;
      isCurrent: boolean;
      isLast: boolean;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    player?: {
      __typename: 'Player';
      id: string;
      name: string;
      gameStatus: PlayerGameStatus;
      connectionStatus: PlayerConnectionStatus;
      feelingBefore?: number | null;
      feelingAfter?: number | null;
      question?: string | null;
      questionAnswer?: boolean | null;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    artworkReactions: Array<{
      __typename: 'ArtworkReaction';
      id: string;
      reaction: number;
      playerCardId: string;
      playerId: string;
      sessionId: string;
      playerCard?: {
        __typename: 'PlayerCard';
        id: string;
        drawing?: string | null;
        drawingLines?: string | null;
        timesStoryMadeFeelGood: number;
        timesStoryWasRelated: number;
        timesStoryWasShared: number;
        gameId: string;
        playerId: string;
        sessionId: string;
        game?: {
          __typename: 'Game';
          id: string;
          promptText: string;
          promptGamePackId?: string | null;
          status: GameStatus;
          gameIndex: number;
          isCurrent: boolean;
          isLast: boolean;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        player?: {
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        artworkReactions: Array<{
          __typename: 'ArtworkReaction';
          id: string;
          reaction: number;
          playerCardId: string;
          playerId: string;
          sessionId: string;
          playerCard?: {
            __typename: 'PlayerCard';
            id: string;
            drawing?: string | null;
            drawingLines?: string | null;
            timesStoryMadeFeelGood: number;
            timesStoryWasRelated: number;
            timesStoryWasShared: number;
            gameId: string;
            playerId: string;
            sessionId: string;
            createdAt: string;
            updatedAt: string;
          } | null;
          player?: {
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
        }>;
        createdAt: string;
        updatedAt: string;
      } | null;
      player?: {
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
    }>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PlayerCardListByGameQueryVariables = {
  gameId: string;
};

export type PlayerCardListByGameQuery = {
  playerCardListByGame: Array<{
    __typename: 'PlayerCard';
    id: string;
    drawing?: string | null;
    drawingLines?: string | null;
    timesStoryMadeFeelGood: number;
    timesStoryWasRelated: number;
    timesStoryWasShared: number;
    gameId: string;
    playerId: string;
    sessionId: string;
    game?: {
      __typename: 'Game';
      id: string;
      promptText: string;
      promptGamePackId?: string | null;
      status: GameStatus;
      gameIndex: number;
      isCurrent: boolean;
      isLast: boolean;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    player?: {
      __typename: 'Player';
      id: string;
      name: string;
      gameStatus: PlayerGameStatus;
      connectionStatus: PlayerConnectionStatus;
      feelingBefore?: number | null;
      feelingAfter?: number | null;
      question?: string | null;
      questionAnswer?: boolean | null;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    artworkReactions: Array<{
      __typename: 'ArtworkReaction';
      id: string;
      reaction: number;
      playerCardId: string;
      playerId: string;
      sessionId: string;
      playerCard?: {
        __typename: 'PlayerCard';
        id: string;
        drawing?: string | null;
        drawingLines?: string | null;
        timesStoryMadeFeelGood: number;
        timesStoryWasRelated: number;
        timesStoryWasShared: number;
        gameId: string;
        playerId: string;
        sessionId: string;
        game?: {
          __typename: 'Game';
          id: string;
          promptText: string;
          promptGamePackId?: string | null;
          status: GameStatus;
          gameIndex: number;
          isCurrent: boolean;
          isLast: boolean;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        player?: {
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        artworkReactions: Array<{
          __typename: 'ArtworkReaction';
          id: string;
          reaction: number;
          playerCardId: string;
          playerId: string;
          sessionId: string;
          playerCard?: {
            __typename: 'PlayerCard';
            id: string;
            drawing?: string | null;
            drawingLines?: string | null;
            timesStoryMadeFeelGood: number;
            timesStoryWasRelated: number;
            timesStoryWasShared: number;
            gameId: string;
            playerId: string;
            sessionId: string;
            createdAt: string;
            updatedAt: string;
          } | null;
          player?: {
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
        }>;
        createdAt: string;
        updatedAt: string;
      } | null;
      player?: {
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
    }>;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type PlayerCardListByPlayerQueryVariables = {
  playerId: string;
};

export type PlayerCardListByPlayerQuery = {
  playerCardListByPlayer: Array<{
    __typename: 'PlayerCard';
    id: string;
    drawing?: string | null;
    drawingLines?: string | null;
    timesStoryMadeFeelGood: number;
    timesStoryWasRelated: number;
    timesStoryWasShared: number;
    gameId: string;
    playerId: string;
    sessionId: string;
    game?: {
      __typename: 'Game';
      id: string;
      promptText: string;
      promptGamePackId?: string | null;
      status: GameStatus;
      gameIndex: number;
      isCurrent: boolean;
      isLast: boolean;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    player?: {
      __typename: 'Player';
      id: string;
      name: string;
      gameStatus: PlayerGameStatus;
      connectionStatus: PlayerConnectionStatus;
      feelingBefore?: number | null;
      feelingAfter?: number | null;
      question?: string | null;
      questionAnswer?: boolean | null;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    artworkReactions: Array<{
      __typename: 'ArtworkReaction';
      id: string;
      reaction: number;
      playerCardId: string;
      playerId: string;
      sessionId: string;
      playerCard?: {
        __typename: 'PlayerCard';
        id: string;
        drawing?: string | null;
        drawingLines?: string | null;
        timesStoryMadeFeelGood: number;
        timesStoryWasRelated: number;
        timesStoryWasShared: number;
        gameId: string;
        playerId: string;
        sessionId: string;
        game?: {
          __typename: 'Game';
          id: string;
          promptText: string;
          promptGamePackId?: string | null;
          status: GameStatus;
          gameIndex: number;
          isCurrent: boolean;
          isLast: boolean;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        player?: {
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        artworkReactions: Array<{
          __typename: 'ArtworkReaction';
          id: string;
          reaction: number;
          playerCardId: string;
          playerId: string;
          sessionId: string;
          playerCard?: {
            __typename: 'PlayerCard';
            id: string;
            drawing?: string | null;
            drawingLines?: string | null;
            timesStoryMadeFeelGood: number;
            timesStoryWasRelated: number;
            timesStoryWasShared: number;
            gameId: string;
            playerId: string;
            sessionId: string;
            createdAt: string;
            updatedAt: string;
          } | null;
          player?: {
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
        }>;
        createdAt: string;
        updatedAt: string;
      } | null;
      player?: {
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
    }>;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type PlayerCardListBySessionQueryVariables = {
  sessionId: string;
};

export type PlayerCardListBySessionQuery = {
  playerCardListBySession: Array<{
    __typename: 'PlayerCardDrawings';
    id: string;
    drawing?: string | null;
    drawingLines?: string | null;
    gameId: string;
    player?: {
      __typename: 'PlayerName';
      name: string;
    } | null;
  }>;
};

export type PlayerCardGetByGameAndPlayerQueryVariables = {
  gameId: string;
  playerId: string;
};

export type PlayerCardGetByGameAndPlayerQuery = {
  playerCardGetByGameAndPlayer?: {
    __typename: 'PlayerCard';
    id: string;
    drawing?: string | null;
    drawingLines?: string | null;
    timesStoryMadeFeelGood: number;
    timesStoryWasRelated: number;
    timesStoryWasShared: number;
    gameId: string;
    playerId: string;
    sessionId: string;
    game?: {
      __typename: 'Game';
      id: string;
      promptText: string;
      promptGamePackId?: string | null;
      status: GameStatus;
      gameIndex: number;
      isCurrent: boolean;
      isLast: boolean;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      createdAt: string;
      updatedAt: string;
    } | null;
    player?: {
      __typename: 'Player';
      id: string;
      name: string;
      gameStatus: PlayerGameStatus;
      connectionStatus: PlayerConnectionStatus;
      feelingBefore?: number | null;
      feelingAfter?: number | null;
      question?: string | null;
      questionAnswer?: boolean | null;
      sessionId: string;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    session?: {
      __typename: 'Session';
      id: string;
      hostId?: string | null;
      data: {
        __typename: 'SessionData';
        status: SessionStatus;
        players: Array<{
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        }>;
        rounds: Array<{
          __typename: 'Round';
          id: string;
          index: number;
          isCurrent: boolean;
          isLast: boolean;
          promptId: string;
          artwork: Array<{
            __typename: 'Artwork';
            id: string;
            drawing: string;
            playerId: string;
          }>;
        }>;
        questionType: QuestionType;
      };
      organizationId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
    } | null;
    artworkReactions: Array<{
      __typename: 'ArtworkReaction';
      id: string;
      reaction: number;
      playerCardId: string;
      playerId: string;
      sessionId: string;
      playerCard?: {
        __typename: 'PlayerCard';
        id: string;
        drawing?: string | null;
        drawingLines?: string | null;
        timesStoryMadeFeelGood: number;
        timesStoryWasRelated: number;
        timesStoryWasShared: number;
        gameId: string;
        playerId: string;
        sessionId: string;
        game?: {
          __typename: 'Game';
          id: string;
          promptText: string;
          promptGamePackId?: string | null;
          status: GameStatus;
          gameIndex: number;
          isCurrent: boolean;
          isLast: boolean;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          createdAt: string;
          updatedAt: string;
        } | null;
        player?: {
          __typename: 'Player';
          id: string;
          name: string;
          gameStatus: PlayerGameStatus;
          connectionStatus: PlayerConnectionStatus;
          feelingBefore?: number | null;
          feelingAfter?: number | null;
          question?: string | null;
          questionAnswer?: boolean | null;
          sessionId: string;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        artworkReactions: Array<{
          __typename: 'ArtworkReaction';
          id: string;
          reaction: number;
          playerCardId: string;
          playerId: string;
          sessionId: string;
          playerCard?: {
            __typename: 'PlayerCard';
            id: string;
            drawing?: string | null;
            drawingLines?: string | null;
            timesStoryMadeFeelGood: number;
            timesStoryWasRelated: number;
            timesStoryWasShared: number;
            gameId: string;
            playerId: string;
            sessionId: string;
            createdAt: string;
            updatedAt: string;
          } | null;
          player?: {
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
          session?: {
            __typename: 'Session';
            id: string;
            hostId?: string | null;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          } | null;
        }>;
        createdAt: string;
        updatedAt: string;
      } | null;
      player?: {
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
      session?: {
        __typename: 'Session';
        id: string;
        hostId?: string | null;
        data: {
          __typename: 'SessionData';
          status: SessionStatus;
          players: Array<{
            __typename: 'Player';
            id: string;
            name: string;
            gameStatus: PlayerGameStatus;
            connectionStatus: PlayerConnectionStatus;
            feelingBefore?: number | null;
            feelingAfter?: number | null;
            question?: string | null;
            questionAnswer?: boolean | null;
            sessionId: string;
            organizationId?: string | null;
            createdAt?: string | null;
            updatedAt?: string | null;
          }>;
          rounds: Array<{
            __typename: 'Round';
            id: string;
            index: number;
            isCurrent: boolean;
            isLast: boolean;
            promptId: string;
          }>;
          questionType: QuestionType;
        };
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      } | null;
    }>;
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type PlayerCardGetReactionCountsQueryVariables = {
  id: string;
};

export type PlayerCardGetReactionCountsQuery = {
  playerCardGetReactionCounts?: {
    __typename: 'PlayerCardReactionCounts';
    feelGood: number;
    related: number;
    shared: number;
  } | null;
};

export type GamePackPromptsGetQueryVariables = {
  id: string;
};

export type GamePackPromptsGetQuery = {
  gamePackPromptsGet?: {
    __typename: 'GamePackPrompts';
    id: string;
    promptId: string;
    gamePackId: string;
    prompt: {
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackPromptsListQueryVariables = {};

export type GamePackPromptsListQuery = {
  gamePackPromptsList: Array<{
    __typename: 'GamePackPrompts';
    id: string;
    promptId: string;
    gamePackId: string;
    prompt: {
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GamePackPromptsByPromptIdQueryVariables = {
  promptId: string;
};

export type GamePackPromptsByPromptIdQuery = {
  gamePackPromptsByPromptId: Array<{
    __typename: 'GamePackPrompts';
    id: string;
    promptId: string;
    gamePackId: string;
    prompt: {
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GamePackPromptsByGamePackIdQueryVariables = {
  gamePackId: string;
};

export type GamePackPromptsByGamePackIdQuery = {
  gamePackPromptsByGamePackId: Array<{
    __typename: 'GamePackPrompts';
    id: string;
    promptId: string;
    gamePackId: string;
    prompt: {
      __typename: 'Prompt';
      id: string;
      text: string;
      subdomain?: string | null;
      deletedAt?: string | null;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GamePackOrganizationsGetQueryVariables = {
  id: string;
};

export type GamePackOrganizationsGetQuery = {
  gamePackOrganizationsGet?: {
    __typename: 'GamePackOrganizations';
    id: string;
    gamePackId: string;
    organizationId: string;
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    organization: {
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  } | null;
};

export type GamePackOrganizationsListQueryVariables = {};

export type GamePackOrganizationsListQuery = {
  gamePackOrganizationsList: Array<{
    __typename: 'GamePackOrganizations';
    id: string;
    gamePackId: string;
    organizationId: string;
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    organization: {
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GamePackOrganizationsByGamePackIdQueryVariables = {
  gamePackId: string;
};

export type GamePackOrganizationsByGamePackIdQuery = {
  gamePackOrganizationsByGamePackId: Array<{
    __typename: 'GamePackOrganizations';
    id: string;
    gamePackId: string;
    organizationId: string;
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    organization: {
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  }>;
};

export type GamePackOrganizationsByOrganizationIdQueryVariables = {
  organizationId: string;
};

export type GamePackOrganizationsByOrganizationIdQuery = {
  gamePackOrganizationsByOrganizationId: Array<{
    __typename: 'GamePackOrganizations';
    id: string;
    gamePackId: string;
    organizationId: string;
    gamePack: {
      __typename: 'GamePack';
      id: string;
      name: string;
      description: string;
      category1?: string | null;
      category2?: string | null;
      category3?: string | null;
      icon: GamePackIcon;
      palette: GamePackPalette;
      isFeatured: boolean;
      showInDiscover: boolean;
      isNew: boolean;
      order: number;
      groups?: Array<string> | null;
      status: GamePackStatus;
      prompts?: Array<{
        __typename: 'Prompt';
        id: string;
        text: string;
        subdomain?: string | null;
        deletedAt?: string | null;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      organizations?: Array<{
        __typename: 'Organization';
        id: string;
        name: string;
        tenant: string;
        subdomain: string;
        emailDomains: Array<string>;
        groupsCanRead?: Array<string> | null;
        organizationActive?: boolean | null;
        hostLicenses: number;
        adminLicenses: number;
        gamePacks?: Array<{
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        activeUsers?: number | null;
        activeHosts?: number | null;
        activeAdmins?: number | null;
        onFreeTrial: boolean;
        freeTrialExpiration?: string | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackPrompts?: Array<{
        __typename: 'GamePackPrompts';
        id: string;
        promptId: string;
        gamePackId: string;
        prompt: {
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      createdAt: string;
      updatedAt: string;
    };
    organization: {
      __typename: 'Organization';
      id: string;
      name: string;
      tenant: string;
      subdomain: string;
      emailDomains: Array<string>;
      groupsCanRead?: Array<string> | null;
      organizationActive?: boolean | null;
      hostLicenses: number;
      adminLicenses: number;
      gamePacks?: Array<{
        __typename: 'GamePack';
        id: string;
        name: string;
        description: string;
        category1?: string | null;
        category2?: string | null;
        category3?: string | null;
        icon: GamePackIcon;
        palette: GamePackPalette;
        isFeatured: boolean;
        showInDiscover: boolean;
        isNew: boolean;
        order: number;
        groups?: Array<string> | null;
        status: GamePackStatus;
        prompts?: Array<{
          __typename: 'Prompt';
          id: string;
          text: string;
          subdomain?: string | null;
          deletedAt?: string | null;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        organizations?: Array<{
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackPrompts?: Array<{
          __typename: 'GamePackPrompts';
          id: string;
          promptId: string;
          gamePackId: string;
          prompt: {
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        gamePackOrganizations?: Array<{
          __typename: 'GamePackOrganizations';
          id: string;
          gamePackId: string;
          organizationId: string;
          gamePack: {
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          };
          organization: {
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          };
          createdAt: string;
          updatedAt: string;
        }> | null;
        createdAt: string;
        updatedAt: string;
      }> | null;
      gamePackOrganizations?: Array<{
        __typename: 'GamePackOrganizations';
        id: string;
        gamePackId: string;
        organizationId: string;
        gamePack: {
          __typename: 'GamePack';
          id: string;
          name: string;
          description: string;
          category1?: string | null;
          category2?: string | null;
          category3?: string | null;
          icon: GamePackIcon;
          palette: GamePackPalette;
          isFeatured: boolean;
          showInDiscover: boolean;
          isNew: boolean;
          order: number;
          groups?: Array<string> | null;
          status: GamePackStatus;
          prompts?: Array<{
            __typename: 'Prompt';
            id: string;
            text: string;
            subdomain?: string | null;
            deletedAt?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          organizations?: Array<{
            __typename: 'Organization';
            id: string;
            name: string;
            tenant: string;
            subdomain: string;
            emailDomains: Array<string>;
            groupsCanRead?: Array<string> | null;
            organizationActive?: boolean | null;
            hostLicenses: number;
            adminLicenses: number;
            activeUsers?: number | null;
            activeHosts?: number | null;
            activeAdmins?: number | null;
            onFreeTrial: boolean;
            freeTrialExpiration?: string | null;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackPrompts?: Array<{
            __typename: 'GamePackPrompts';
            id: string;
            promptId: string;
            gamePackId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          createdAt: string;
          updatedAt: string;
        };
        organization: {
          __typename: 'Organization';
          id: string;
          name: string;
          tenant: string;
          subdomain: string;
          emailDomains: Array<string>;
          groupsCanRead?: Array<string> | null;
          organizationActive?: boolean | null;
          hostLicenses: number;
          adminLicenses: number;
          gamePacks?: Array<{
            __typename: 'GamePack';
            id: string;
            name: string;
            description: string;
            category1?: string | null;
            category2?: string | null;
            category3?: string | null;
            icon: GamePackIcon;
            palette: GamePackPalette;
            isFeatured: boolean;
            showInDiscover: boolean;
            isNew: boolean;
            order: number;
            groups?: Array<string> | null;
            status: GamePackStatus;
            createdAt: string;
            updatedAt: string;
          }> | null;
          gamePackOrganizations?: Array<{
            __typename: 'GamePackOrganizations';
            id: string;
            gamePackId: string;
            organizationId: string;
            createdAt: string;
            updatedAt: string;
          }> | null;
          activeUsers?: number | null;
          activeHosts?: number | null;
          activeAdmins?: number | null;
          onFreeTrial: boolean;
          freeTrialExpiration?: string | null;
          createdAt: string;
          updatedAt: string;
        };
        createdAt: string;
        updatedAt: string;
      }> | null;
      activeUsers?: number | null;
      activeHosts?: number | null;
      activeAdmins?: number | null;
      onFreeTrial: boolean;
      freeTrialExpiration?: string | null;
      createdAt: string;
      updatedAt: string;
    };
    createdAt: string;
    updatedAt: string;
  }>;
};

export type ArtworkReactionListQueryVariables = {
  filter: ArtworkReactionFilterInput;
};

export type ArtworkReactionListQuery = {
  artworkReactionList: Array<{
    __typename: 'RedisArtworkReaction';
    reaction: number;
    playerCardId: string;
    playerId: string;
    sessionId: string;
  }>;
};

export type ArtworkReactionCountBySessionQueryVariables = {
  sessionId: string;
};

export type ArtworkReactionCountBySessionQuery = {
  artworkReactionCountBySession: Array<{
    __typename: 'ReactionCount';
    reactionType: number;
    count: number;
  }>;
};

export type MetricsByTenantQueryVariables = {
  tenantId: string;
};

export type MetricsByTenantQuery = {
  metricsByTenant?: {
    __typename: 'Metrics';
    updatedAt?: string | null;
    sentimentIncrease: number;
    totalPlayers: number;
    sentimentCount: number;
    gamesHosted: number;
    questionScore: Array<{
      __typename: 'MetricEntry';
      label: string;
      value: number;
    }>;
    reactionScore: Array<{
      __typename: 'MetricEntry';
      label: string;
      value: number;
    }>;
    totalHosts?: number | null;
    storiesShared?: number | null;
    medianRoundTime?: number | null;
    popularPrompt?: string | null;
    popularGamePack?: string | null;
    avgPlayersPerGame?: number | null;
    avgRoundsPerGame?: number | null;
    avgGameLengthMin?: number | null;
    activityTimeline: Array<{
      __typename: 'MetricEntry';
      label: string;
      value: number;
    }>;
    customPromptsCount?: number | null;
  } | null;
};

export type MetricsByHostQueryVariables = {
  hostId: string;
};

export type MetricsByHostQuery = {
  metricsByHost?: {
    __typename: 'Metrics';
    updatedAt?: string | null;
    sentimentIncrease: number;
    totalPlayers: number;
    sentimentCount: number;
    gamesHosted: number;
    questionScore: Array<{
      __typename: 'MetricEntry';
      label: string;
      value: number;
    }>;
    reactionScore: Array<{
      __typename: 'MetricEntry';
      label: string;
      value: number;
    }>;
    totalHosts?: number | null;
    storiesShared?: number | null;
    medianRoundTime?: number | null;
    popularPrompt?: string | null;
    popularGamePack?: string | null;
    avgPlayersPerGame?: number | null;
    avgRoundsPerGame?: number | null;
    avgGameLengthMin?: number | null;
    activityTimeline: Array<{
      __typename: 'MetricEntry';
      label: string;
      value: number;
    }>;
    customPromptsCount?: number | null;
  } | null;
};

export type AsyncTaskQueryVariables = {
  id: string;
};

export type AsyncTaskQuery = {
  asyncTask?: {
    __typename: 'AsyncTask';
    id: string;
    type: string;
    status: AsyncTaskStatus;
    payload?: string | null;
    result?: string | null;
    error?: string | null;
    createdBy?: string | null;
    tenant?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type SessionUpdatedSubscriptionVariables = {
  id: string;
};

export type SessionUpdatedSubscription = {
  sessionUpdated?: {
    __typename: 'Session';
    id: string;
    hostId?: string | null;
    data: {
      __typename: 'SessionData';
      status: SessionStatus;
      players: Array<{
        __typename: 'Player';
        id: string;
        name: string;
        gameStatus: PlayerGameStatus;
        connectionStatus: PlayerConnectionStatus;
        feelingBefore?: number | null;
        feelingAfter?: number | null;
        question?: string | null;
        questionAnswer?: boolean | null;
        sessionId: string;
        session?: {
          __typename: 'Session';
          id: string;
          hostId?: string | null;
          data: {
            __typename: 'SessionData';
            status: SessionStatus;
            questionType: QuestionType;
          };
          organizationId?: string | null;
          createdAt?: string | null;
          updatedAt?: string | null;
        } | null;
        organizationId?: string | null;
        createdAt?: string | null;
        updatedAt?: string | null;
      }>;
      rounds: Array<{
        __typename: 'Round';
        id: string;
        index: number;
        isCurrent: boolean;
        isLast: boolean;
        promptId: string;
        artwork: Array<{
          __typename: 'Artwork';
          id: string;
          drawing: string;
          playerId: string;
        }>;
      }>;
      questionType: QuestionType;
    };
    organizationId?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};

export type HostSessionUpdatedSubscriptionVariables = {
  id: string;
};

export type HostSessionUpdatedSubscription = {
  hostSessionUpdated:
    | (
        | {
            __typename: 'NewPlayerUpdate';
            player: {
              __typename: string;
              id: string;
              name: string;
              gameStatus: PlayerGameStatus;
              connectionStatus: PlayerConnectionStatus;
              feelingBefore?: number | null;
              feelingAfter?: number | null;
              question?: string | null;
              questionAnswer?: boolean | null;
              sessionId: string;
              session?: {
                __typename: string;
                id: string;
                hostId?: string | null;
                data: {
                  __typename: string;
                  status: SessionStatus;
                  players: Array<{
                    __typename: string;
                    id: string;
                    name: string;
                    gameStatus: PlayerGameStatus;
                    connectionStatus: PlayerConnectionStatus;
                    feelingBefore?: number | null;
                    feelingAfter?: number | null;
                    question?: string | null;
                    questionAnswer?: boolean | null;
                    sessionId: string;
                    organizationId?: string | null;
                    createdAt?: string | null;
                    updatedAt?: string | null;
                  }>;
                  rounds: Array<{
                    __typename: string;
                    id: string;
                    index: number;
                    isCurrent: boolean;
                    isLast: boolean;
                    promptId: string;
                  }>;
                  questionType: QuestionType;
                };
                organizationId?: string | null;
                createdAt?: string | null;
                updatedAt?: string | null;
              } | null;
              organizationId?: string | null;
              createdAt?: string | null;
              updatedAt?: string | null;
            };
          }
        | {
            __typename: 'NewDrawingUpdate';
            artwork?: {
              __typename: string;
              id: string;
              drawing: string;
              playerId: string;
            } | null;
          }
        | {
            __typename: 'NewReactionUpdate';
            reaction?: {
              __typename: string;
              reaction: number;
              playerCardId: string;
              playerId: string;
              sessionId: string;
            } | null;
          }
        | {
            __typename: 'SessionStatusUpdate';
            status: SessionStatus;
          }
      )
    | null;
};

export type PlayerSessionUpdatedSubscriptionVariables = {
  id: string;
};

export type PlayerSessionUpdatedSubscription = {
  playerSessionUpdated:
    | (
        | {
            __typename: 'NewRoundUpdate';
            round: number;
            sessionStatus: SessionStatus;
            playerStatus: PlayerGameStatus;
          }
        | {
            __typename: 'SharingPlayer';
            playerId: string;
          }
        | {
            __typename: 'NewDrawingUpdate';
            artwork?: {
              __typename: string;
              id: string;
              drawing: string;
              playerId: string;
            } | null;
          }
        | {
            __typename: 'NewPlayerUpdate';
            player: {
              __typename: string;
              id: string;
              name: string;
              gameStatus: PlayerGameStatus;
              connectionStatus: PlayerConnectionStatus;
              feelingBefore?: number | null;
              feelingAfter?: number | null;
              question?: string | null;
              questionAnswer?: boolean | null;
              sessionId: string;
              session?: {
                __typename: string;
                id: string;
                hostId?: string | null;
                data: {
                  __typename: string;
                  status: SessionStatus;
                  players: Array<{
                    __typename: string;
                    id: string;
                    name: string;
                    gameStatus: PlayerGameStatus;
                    connectionStatus: PlayerConnectionStatus;
                    feelingBefore?: number | null;
                    feelingAfter?: number | null;
                    question?: string | null;
                    questionAnswer?: boolean | null;
                    sessionId: string;
                    organizationId?: string | null;
                    createdAt?: string | null;
                    updatedAt?: string | null;
                  }>;
                  rounds: Array<{
                    __typename: string;
                    id: string;
                    index: number;
                    isCurrent: boolean;
                    isLast: boolean;
                    promptId: string;
                  }>;
                  questionType: QuestionType;
                };
                organizationId?: string | null;
                createdAt?: string | null;
                updatedAt?: string | null;
              } | null;
              organizationId?: string | null;
              createdAt?: string | null;
              updatedAt?: string | null;
            };
          }
        | {
            __typename: 'SessionStatusUpdate';
            status: SessionStatus;
          }
      )
    | null;
};

export type AsyncTaskUpdatedSubscriptionVariables = {
  id: string;
};

export type AsyncTaskUpdatedSubscription = {
  asyncTaskUpdated?: {
    __typename: 'AsyncTask';
    id: string;
    type: string;
    status: AsyncTaskStatus;
    payload?: string | null;
    result?: string | null;
    error?: string | null;
    createdBy?: string | null;
    tenant?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
  } | null;
};
